module.exports = __webpack_public_path__ + "static/media/benifits.daefc3db.png";